<template>
  <nav class="grid-layout pa-4 w-100">
    <div class="grid-container">
      <a
        v-for="(item, i) in displayedMedias"
        :key="i"
        class="social-grid-item d-flex flex-column align-center justify-center text-decoration-none glass-effect"
        :style="{
          background: hexToRgba(value.socialMediaIcons?.sectionColor?.backGround, 0.2),
        }"
        @click="$emit('go-to-url', item.url, item.pattern)"
      >
        <div class="icon-box" :style="{ background: getSocialColor(item.name) }">
            <div class="icon">
          <svg-base :view-box="getViewBox(item.name)" style="display: block; margin: auto;">
            <component :is="item.svg" class="mt-0" />
          </svg-base>
        </div>
        </div>
        <span class="mt-2 text-caption font-weight-medium" :style="{ color: value.socialMediaIcons?.sectionColor?.text || '#333' }">
          {{ item.label }}
        </span>
      </a>
    </div>

    <!-- دکمه نمایش بیشتر / کمتر -->
    <div v-if="medias.length > initialLimit" class="toggle-container mt-6">
      <div class="divider-line"></div>
      <div 
        class="toggle-btn text-caption font-weight-bold mx-3 glass-effect"
        :style="{ color: value.socialMediaIcons?.sectionColor?.text || '#333' }"
        @click="isExpanded = !isExpanded"
      >
        {{ isExpanded ? 'نمایش کمتر' : 'نمایش بیشتر' }}
        <v-icon small :color="value.socialMediaIcons?.sectionColor?.text || '#333'">
          {{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
      </div>
      <div class="divider-line"></div>
    </div>
  </nav>
</template>

<script>
import SvgBase from "@/view/content/svgLoader/svgBase";
const viewBoxConfig = {
  digikala: '0 0 1200 1200',
  torob: '0 -20 200 200',        
  emalls: '0 -10 310 310',
  cafebazaar: '-10 -70 370 370',
  basalam: '0 -15 128 128',
  samsung: '0 0 100 100',
  apple: '0 0 100 100',
  snappshop: '-10 -20 80 80',    
  technolife: '0 -40 100 100',
  linkedin_company:'-10 -10 60 60'
};

export default {
  name: "SocialGrid",
  components: { SvgBase },
  props: {
    medias: { type: Array, required: true },
    value: { type: Object, required: true },
    getSocialColor: { type: Function, required: true },
    hexToRgba: { type: Function, required: true }
  },
  data() {
    return {
      isExpanded: false,
      initialLimit: 6, 
    };
  },
  computed: {
    displayedMedias() {
      if (this.isExpanded) {
        return this.medias;
      }
      return this.medias.slice(0, this.initialLimit);
    }
  },
  methods:{
      getViewBox(name) {
      return viewBoxConfig[name] || '0 0 50 50';
    },

  }
};
</script>

<style lang="scss" scoped>
.grid-layout {
  .grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 15px;
    justify-items: center;
  }
  
  .social-grid-item {
    width: 80px;
    height: 100px;
    border-radius: 16px;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 20px rgba(0,0,0,0.15) !important;
    }

    .icon-box {
      width: 55px;
      height: 55px;
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px;
      box-shadow: inset 0 0 10px rgba(255,255,255,0.2);
      
      ::v-deep svg { width: 100%; height: 100%; fill: #fff; }
    }
  }

  // استایل‌های دکمه نمایش بیشتر
  .toggle-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    .divider-line {
      flex-grow: 1;
      height: 1px;
      background: rgba(150, 150, 150, 0.3); // رنگ خطوط
    }

    .toggle-btn {
      display: flex;
      align-items: center;
      padding: 6px 16px;
      border-radius: 20px;
      cursor: pointer;
      user-select: none;
      transition: all 0.3s ease;

      &:active {
        transform: scale(0.95);
      }
    }
  }
}

.glass-effect {
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}
</style>
